var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7552 8.42512C25.7391 6.26087 26.5554 6.6999 26.3204 9.09913C26.3204 9.09913 25.3372 17.045 23.983 24.1128C23.7171 25.498 23.2781 28.3053 20.3904 26.4688C19.772 26.0792 15.7712 23.377 13.6874 21.9486C11.8756 20.7119 13.069 19.7163 13.7554 19.0114L20.2358 12.7474C20.7057 12.3084 20.143 11.8075 19.6978 12.1291C19.6978 12.1291 11.1706 17.886 10.7254 18.1333C9.64948 18.7517 8.77142 19.5617 6.55151 18.9063C4.33161 18.2508 2.16736 17.8365 2.16736 16.9275C2.16736 16.1917 3.70707 15.6908 6.07538 14.652C10.8244 12.5557 20.7552 8.42512 20.7552 8.42512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.c0f4e4f1ef1b3067625227407710509e.svg";
export { ForwardRef as ReactComponent };